import { render, staticRenderFns } from "./LabelChart.vue?vue&type=template&id=7bbb232f&"
import script from "./LabelChart.vue?vue&type=script&lang=js&"
export * from "./LabelChart.vue?vue&type=script&lang=js&"
import style0 from "./LabelChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports